module.exports = __webpack_public_path__ + "img/03.88cff766.png";